<template>
  <div class="default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro"
        @change="filtroChange"
        @cancel="handleCloseFiltro"
      />

    <div class="row">
      <div class="col-12 lbl-deal-title mb-2">
        <span class="lbl-deal-title mb-2 w-100">SALDO EM ESTOQUE</span>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-end">
      <div class="col-md-4 col-12">
        <input-search
          label="Pesquisar item"
          v-model="itemPesquisa"
          entity="item"
          @change="handleItemSelect"
        />
      </div>
      <div class="col-md-3 col-12">
        <label-title label="Status do Estoque" />
        <select class="form-control form-control-sm" v-model="status_estoque">
          <option value="">Todos</option>
          <option value="abaixo_estoque_minimo">Abaixo do estoque mínimo</option>
          <option value="somente_sem_estoque">Somente sem estoque</option>
          <option value="somente_com_estoque">Somente com estoque</option>
          <option value="lotes_vencidos">Somente com lotes vencidos</option>
        </select>
      </div>
      <div class="col-md-3 col-12 pt-2">
        <input-checkbox
          label="Exibir valores (Preço de venda, compra e custo)"
          v-model="filtro.resumoEstoque"
          :value-checked="true"
          :value-unchecked="false"
        ></input-checkbox>
      </div>
      <div class="col-md-2 col-12">
        <v-button icon="fa-search" :success="true" @click="handleSearch" class="mt-4 mr-2"></v-button>
        <v-button icon="fa-filter" :success="true" @click="handleShowFiltro" class="mt-4"></v-button>
      </div>
    </div>
    <div class="row mb-3" v-if="dados.total">
      <div class="col-12">
        <div class="nb-dash-card">
          <div class="nb-dash-title">
            <span class="w-100">Resumo do Estoque</span>
          </div>
          <div class="row p-3">
            <div class="col-md-4 col-12 mb-2">
              <div class="border p-2">
                <span class="nb-dash-lbl w-100">Valor do estoque (preço de venda)</span>
                <span class="nb-dash-total w-100 text-center">R$ {{dados.total.total_vlrvenda | formatValue(2, true)}}</span>
              </div>
            </div>
            <div class="col-md-4 col-12 mb-2">
              <div class="border p-2">
                <span class="nb-dash-lbl w-100">Valor do estoque (preço de custo)</span>
                <span class="nb-dash-total w-100 text-center">R$ {{dados.total.total_custo | formatValue(2, true)}}</span>
              </div>
            </div>
            <div class="col-md-4 col-12 mb-2">
              <div class="border p-2">
                <span class="nb-dash-lbl w-100">Valor do estoque (preço de compra)</span>
                <span class="nb-dash-total w-100 text-center">R$ {{dados.total.total_vlrcompra | formatValue(2, true)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 lbl-title mb-2">
        SALDO
        <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
        <span class="float-right mr-5 d-flex align-items-center mt-3"><span class="var-negative legend border mr-2"></span> <small style="font-size:10px">Abaixo do mínimo</small></span>
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table id="relatorio" class="table  table-striped table-hover responsive tablesorter w-100" >
              <thead>
                  <tr style="height: 37px">
                      <th :class="col.tp + ' header '" style="" title="" v-for="(col, index) in tableColumns" :key="index" > {{ col.label }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                  </tr>
              </thead>
              <tbody>
                  <tr style="height: 37px" :class="row.qtuni < row.qtmin ? 'var-negative' : '' " v-for="(row, index) in dados.items" :key="index">
                      <td class="textual"><span>{{row.codigo}}</span></td>
                      <td class="textual">
                        <span>{{row.descricao}}</span>
                        <span v-if="row.linha || row.coluna"><strong> ({{row.linha}} / {{row.coluna}})</strong></span>
                      </td>
                      <td class="textual"><span>{{row.uni}}</span></td>
                      <td class="numerico"><span>{{row.qt}}</span></td>
                      <td class="numerico"><span>{{row.qtmin}}</span></td>
                      <!-- <td class="numerico"><span>{{row.qtres}}</span></td> -->
                      <td class="numerico" v-if="filtro.resumoEstoque"><span>{{row.vlrvenda | formatValue(2, true)}}</span></td>
                      <td class="numerico" v-if="filtro.resumoEstoque"><span>{{row.vlrcompra | formatValue(2, true)}}</span></td>
                      <td class="numerico" v-if="filtro.resumoEstoque"><span>{{row.custo | formatValue(2, true)}}</span></td>
                  </tr>
              </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { SysVars } from '../main'
import { apiORDSpost, apiORDS } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,
      tableColumns: [],
      dados: {},
      dadosGrafico: null,

      itemPesquisa: '',
      status_estoque: '',

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        checkbox:[
        ],
        filtros: [
          {
            nome: "grupoestoque",
            label: 'Grupo de Produtos',
            url: null,
            varios: true,
            values: [],
          },
        ],
      },

      filtro: {
 //       periodos: [{ data_inicio: null, data_termino: null }],
          resumoEstoque: true,
      },

      colunas: [
      ],

      nextPage: false,

    };
  },
  watch: {
    itemPesquisa: function(newVal) {
      if (!newVal) {
        delete this.filtro.produto;
        delete this.filtro.descricao;
      } else {
        // Delay to allow handleItemSelect to process first if an item was clicked
        setTimeout(() => {
          if (!this.filtro.produto || String(this.filtro.produto[0]) !== String(newVal)) {
            delete this.filtro.produto;
            this.filtro.descricao = newVal;
          }
        }, 100);
      }
    },
    status_estoque: function(newVal) {
      this.filtro.abaixo_estoque_minimo = (newVal === 'abaixo_estoque_minimo');
      this.filtro.somente_sem_estoque = (newVal === 'somente_sem_estoque');
      this.filtro.somente_com_estoque = (newVal === 'somente_com_estoque');
      this.filtro.lotes_vencidos = (newVal === 'lotes_vencidos');
    }
  },

  methods: {
    handleSearch() {
      this.loadData();
    },
    handleItemSelect(item) {
      if (item && (item.id || item.codigo)) {
        this.filtro.produto = [item.id || item.codigo];
        delete this.filtro.descricao;
      }
    },
    handleCloseFiltro(){
      this.showfiltro = false
    },
    handleCancel(){
      this.showfiltro = false
    },

    clickRetornar () {
      this.$router.push('/')
    },

    loadCols () {
        if(!this.filtro.resumoEstoque){
          this.tableColumns = [
              {label: 'Código', tp:'textual'},
              {label: 'Descrição', tp:'textual'},
              {label: 'Unitario', tp:'textual'},
              {label: 'Qtd Estoque', tp: 'numerico'},
              {label: 'Qtd Minima', tp:'numerico'},
              //{label: 'Qtd Reservada', tp: 'numerico'},
          ]
        } else{
          this.tableColumns = [
              {label: 'Código', tp:'textual'},
              {label: 'Descrição', tp:'textual'},
              {label: 'Unitario', tp:'textual'},
              {label: 'Qtd Estoque', tp: 'numerico'},
              {label: 'Qtd Minima', tp:'numerico'},
              //{label: 'Qtd Reservada', tp: 'numerico'},
              {label: 'Preço de venda', tp:'numerico'},
              {label: 'Preço de compra', tp: 'numerico'},
              {label: 'Custo', tp: 'numerico'}
          ]
        }
    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;

      // Mantém os filtros da tela principal
      filtro.resumoEstoque = this.filtro.resumoEstoque;
      filtro.abaixo_estoque_minimo = this.filtro.abaixo_estoque_minimo;
      filtro.somente_sem_estoque = this.filtro.somente_sem_estoque;
      filtro.somente_com_estoque = this.filtro.somente_com_estoque;
      filtro.lotes_vencidos = this.filtro.lotes_vencidos;

      if (this.filtro.produto) filtro.produto = this.filtro.produto;
      if (this.filtro.descricao) filtro.descricao = this.filtro.descricao;

      this.filtro = filtro;

      this.loadData();
    },

    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          this.loadData(false, true)
        }
        SysVars.scrollPosition = document.documentElement.scrollTop
      }
    },

    async loadData(excel, loadMore) {

       let url = "consulta/estoque/saldoestoque";
       // let url = "consulta/teste";

       if (loadMore)
         if (this.dados.has_more) {
           this.filtro.page = this.dados.next_page
           this.nextPage = true
         }
         else
           return

       this.filtro.excel = excel

       if (excel)
         apiDownload2(this, url, this.filtro, "post")
       else {
         const data = await apiORDSpost(this.$store, url, this.filtro, "post")
         if (data) {
           if (loadMore) {
             this.dados.items.push(...data.items)
             this.dados.has_more = data.has_more
             this.dados.next_page = data.next_page
             // Mantém o total da primeira carga
           }
           else
             this.dados = data
         } else {
           this.dados = {};
         }
         this.loadCols()
       }

       let self = this
       this.$nextTick(function () {
         self.nextPage = false
       })

     },
  },

  mounted() {
    this.scroll()
  },

  destroyed () {
    window.onscroll = null
  },

  created() {
    this.loadCols();
  },
}


</script>

<style>
.nb-dash-title {
  padding: 10px 16px;
  border-bottom: 1px solid #f7f7f7;
  color: #adadad;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.nb-dash-lbl {
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 18px;
  color: #757575 !important;
  font-size: 13px;
  letter-spacing: normal;
  max-width: 100%;
  float: left;
}

.nb-dash-total {
  display: inline-block;
  max-width: 100%;
  margin: 25px 0 25px 0;
  color: #656565;
  font-size: 26px;
  font-weight: 400;
}

.legend{
    padding: 5px 5px;

}
table .textual {
    font-size: 12px;
    text-align: left;
}

table .numerico {
    font-size: 12px;
    min-width: 65px;
    text-align: center;
}

table .size130 {
  min-width: 130px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative, .var-negative {
    color: white;
    background: indianred!important;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.resumo__performance {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.resumo__performance__value {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    border-radius: 10%;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-saldo-estoque.vue